import request from "@/utils/axios";

function gettype(dtype) {
  return request({
    url: "/Dictionary/GetListtype?dtype=" + dtype,
    method: "Get",
  });
}
function initGlobalDicCatch() {
  request({
    url: "/Dictionary/AllList",
    method: "POST",
  }).then((res) => {
    // 1. 以前的逻辑暂不变
    sessionStorage.DictionaryCatch = JSON.stringify(formatGlobalDict(res.data.data));
    // 2. 全局存储字典
    // window.GLOBAL_DICT = formatGlobalDict(res.data.data);
  });
}
// 格式化初始字典数据
function formatGlobalDict(dictList) {
  const dictObj = {};
  dictList.forEach((item) => {
    if (!dictObj[item.dtype]) {
      dictObj[item.dtype] = [];
    }
    dictObj[item.dtype].push(item);
  });
  return dictObj;
}
export default { gettype, initGlobalDicCatch };
